import React from "react";
import Navbar from "../../Components/Navigation/Navbar";
import { Button, Card, ListGroup } from "react-bootstrap";

function OrdersPage() {
    return (
        <>
            <Navbar />
            <Card>
                <Card.Header>Satzung und Ordnungen</Card.Header>
                <Card.Body>
                    <Card.Text>
                        Hier findet Ihr unsere Vereinssatzung, Geschäftsordnung und Beitragsordnung zum Download als PDF.
                        <ListGroup>
                            <ListGroup.Item>
                                <a href="/pdfs/Satzung.pdf" target="_blank" rel="noopener noreferrer">Satzung (PDF)</a>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <a href="/pdfs/Beitragsordnung.pdf" target="_blank" rel="noopener noreferrer">Beitragsordnung (PDF)</a>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <a href="/pdfs/Schwimmhallenordnung.pdf" target="_blank" rel="noopener noreferrer">Schwimmhallenordnung (PDF)</a>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <a href="/pdfs/Geschäftsordnung.pdf" target="_blank" rel="noopener noreferrer">Geschäftsordnung (PDF)</a>
                            </ListGroup.Item>
                            <ListGroup.Item>
                                <a href="/pdfs/Ehrenordnung.pdf" target="_blank" rel="noopener noreferrer">Ehrenordnung (PDF)</a>
                            </ListGroup.Item>
                        </ListGroup>
                    </Card.Text>
                </Card.Body>
            </Card>

            <Card className="impressum">
                <Button variant="Link" href="/impressum">Impressum</Button>
            </Card>
        </>
    );
}

export default OrdersPage;
